import { Converter } from '../types/converter';

export const volumeLumberConverter: Converter = {
  id: 'volumeLumber',
  name: 'Lumber Volume Converter',
  icon: 'Box',
  categories: ['engineering'],
  units: [
    // Base units
    { name: 'Cubic Meter', symbol: 'm³', factor: 1 },
    { name: 'Cubic Foot', symbol: 'ft³', factor: 0.028316847 },
    { name: 'Cubic Inch', symbol: 'in³', factor: 0.000016387064 },
    
    // Board feet units
    { name: 'Board Foot', symbol: 'bf', factor: 0.002359737216 },
    { name: 'Thousand Board Feet', symbol: 'MBF', factor: 2.359737216 },
    
    // Cord measurements
    { name: 'Cord', symbol: 'cord', factor: 3.624556363776 },
    { name: 'Cord (80 Cubic Feet)', symbol: 'cord (80 ft³)', factor: 2.265485295872 },
    { name: 'Cord Feet', symbol: 'cord ft', factor: 0.302046363648 },
    
    // Commercial units
    { name: 'Cunit', symbol: 'cunit', factor: 2.831684659200 },
    { name: 'Pallet', symbol: 'pallet', factor: 1.132673863680 },
    
    // Railroad tie units
    { name: 'Cross Tie', symbol: 'cross tie', factor: 0.068537993252 },
    { name: 'Switch Tie', symbol: 'switch tie', factor: 0.113396655360 },
    
    // Panel measurements (1000 square feet at various thicknesses)
    { name: 'Thousand Square Feet (1/8-inch Panels)', symbol: 'MSF (1/8")', factor: 0.295967152000 },
    { name: 'Thousand Square Feet (1/4-inch Panels)', symbol: 'MSF (1/4")', factor: 0.591934304000 },
    { name: 'Thousand Square Feet (3/8-inch Panels)', symbol: 'MSF (3/8")', factor: 0.887901456000 },
    { name: 'Thousand Square Feet (1/2-inch Panels)', symbol: 'MSF (1/2")', factor: 1.183868608000 },
    { name: 'Thousand Square Feet (3/4-inch Panels)', symbol: 'MSF (3/4")', factor: 1.775802912000 }
  ]
};
